export const useIsHydrating = () => {
    const isHydrating = ref(true);

    onMounted(() => (isHydrating.value = false));

    return {
        isHydrating,
    };
};
